import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import { c as classNames } from '../../shared/bind-d9144132.js';
import { getTestId } from '../../utils/testId.js';
import { idFromName } from '../../utils/html.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "toggle": "web_ui__Toggle__toggle",
  "align-center": "web_ui__Toggle__align-center",
  "text-left": "web_ui__Toggle__text-left",
  "label": "web_ui__Toggle__label",
  "button": "web_ui__Toggle__button",
  "inverse": "web_ui__Toggle__inverse"
};

var cssClasses = classNames.bind(styles);
var Toggle = function Toggle(props) {
  var name = props.name,
    text = props.text,
    checked = props.checked,
    _props$defaultChecked = props.defaultChecked,
    internalDefaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked,
    disabled = props.disabled,
    inverse = props.inverse,
    onClick = props.onClick,
    onChange = props.onChange,
    aria = props.aria,
    testId = props.testId,
    forwardedRef = props.forwardedRef,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? 'right' : _props$labelPosition,
    _props$labelAlignment = props.labelAlignment,
    labelAlignment = _props$labelAlignment === void 0 ? 'top' : _props$labelAlignment;
  var id = idFromName(name);
  var labelStyles = cssClasses(styles.toggle, {
    inverse: inverse,
    'text-left': labelPosition === 'left',
    'align-center': labelAlignment === 'center'
  });
  return /*#__PURE__*/jsxs("label", {
    htmlFor: id,
    className: labelStyles,
    "data-testid": testId,
    children: [/*#__PURE__*/jsx("input", _objectSpread(_objectSpread({
      type: "checkbox",
      role: "switch",
      id: id,
      name: name,
      checked: checked
    }, checked === undefined && internalDefaultChecked && {
      defaultChecked: true
    }), {}, {
      disabled: disabled,
      onClick: onClick,
      onChange: onChange,
      "data-testid": getTestId(testId, 'input'),
      ref: forwardedRef
    }, aria)), /*#__PURE__*/jsx("span", {
      className: styles.button
    }), text ? /*#__PURE__*/jsx("span", {
      className: styles.label,
      "data-testid": getTestId(testId, 'text'),
      children: text
    }) : null]
  });
};

export { Toggle as default };
//# sourceMappingURL=Toggle.js.map
